import { render, staticRenderFns } from "./BaseProjectBox.vue?vue&type=template&id=e4b84d14&scoped=true&"
import script from "./BaseProjectBox.vue?vue&type=script&lang=js&"
export * from "./BaseProjectBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseProjectBox.vue?vue&type=style&index=0&id=e4b84d14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b84d14",
  null
  
)

export default component.exports